import type { Action } from '@forms/types/context-action/action';
import type { FileRequest } from '@forms/types/FileRequest';

export const MODAL_ACTIONS = {
  OPEN_CLEAR_METADATA_TEMPLATE_MODAL: 'OPEN_CLEAR_METADATA_TEMPLATE_MODAL',
  CLOSE_CLEAR_METADATA_TEMPLATE_MODAL: 'CLOSE_CLEAR_METADATA_TEMPLATE_MODAL',
  OPEN_DELETE_FILE_REQUEST_MODAL: 'OPEN_DELETE_FILE_REQUEST_MODAL',
  CLOSE_DELETE_FILE_REQUEST_MODAL: 'CLOSE_DELETE_FILE_REQUEST_MODAL',
  OPEN_SHARE_MODAL: 'OPEN_SHARE_MODAL',
  FILE_REQUEST_UPDATED_FROM_SHARE_MODAL:
    'ACTION_FILE_REQUEST_UPDATED_FROM_SHARE_MODAL',
  CLOSE_SHARE_MODAL: 'CLOSE_SHARE_MODAL',
  OPEN_EXIT_MODAL: 'OPEN_EXIT_MODAL',
  CLOSE_EXIT_MODAL: 'CLOSE_EXIT_MODAL',
  OPEN_COPY_MODAL: 'OPEN_COPY_MODAL',
  CLOSE_COPY_MODAL: 'CLOSE_COPY_MODAL',
  OPEN_SELECT_MODAL: 'OPEN_SELECT_MODAL',
  CLOSE_SELECT_MODAL: 'CLOSE_SELECT_MODAL',
} as const;

export type OpenClearMetadataTemplateModalAction = Action<
  typeof MODAL_ACTIONS.OPEN_CLEAR_METADATA_TEMPLATE_MODAL
>;

export type CloseClearMetadataTemplateModalAction = Action<
  typeof MODAL_ACTIONS.CLOSE_CLEAR_METADATA_TEMPLATE_MODAL
>;

export type OpenDeleteFileRequestModalAction = Action<
  typeof MODAL_ACTIONS.OPEN_DELETE_FILE_REQUEST_MODAL
>;

export type CloseDeleteFileRequestModalAction = Action<
  typeof MODAL_ACTIONS.CLOSE_DELETE_FILE_REQUEST_MODAL
>;

export type OpenShareModalAction = Action<
  typeof MODAL_ACTIONS.OPEN_SHARE_MODAL
>;

export type FileRequestUpdatedFromShareModalAction = Action<
  typeof MODAL_ACTIONS.FILE_REQUEST_UPDATED_FROM_SHARE_MODAL,
  {
    fileRequest: FileRequest;
  }
>;

export type CloseShareModalAction = Action<
  typeof MODAL_ACTIONS.CLOSE_SHARE_MODAL,
  {
    fileRequest: FileRequest;
  }
>;

export type OpenExitModalAction = Action<typeof MODAL_ACTIONS.OPEN_EXIT_MODAL>;

export type CloseExitModalAction = Action<
  typeof MODAL_ACTIONS.CLOSE_EXIT_MODAL
>;

export type OpenCopyModalAction = Action<typeof MODAL_ACTIONS.OPEN_COPY_MODAL>;

export type CloseCopyModalAction = Action<
  typeof MODAL_ACTIONS.CLOSE_COPY_MODAL
>;

export type OpenSelectModalAction = Action<
  typeof MODAL_ACTIONS.OPEN_SELECT_MODAL,
  {
    id: string;
  }
>;

export type CloseSelectModalAction = Action<
  typeof MODAL_ACTIONS.CLOSE_SELECT_MODAL
>;

export type ModalHandlerActions = OpenShareModalAction;
export type ModalReducerActions =
  | OpenClearMetadataTemplateModalAction
  | CloseClearMetadataTemplateModalAction
  | OpenDeleteFileRequestModalAction
  | CloseDeleteFileRequestModalAction
  | FileRequestUpdatedFromShareModalAction
  | CloseShareModalAction
  | OpenExitModalAction
  | CloseExitModalAction
  | OpenCopyModalAction
  | CloseCopyModalAction
  | OpenSelectModalAction
  | CloseSelectModalAction;

export type ModalActions = ModalHandlerActions | ModalReducerActions;
